import { render } from "./analogClock.vue?vue&type=template&id=0bd00e92&scoped=true"
import script from "./analogClock.vue?vue&type=script&lang=js"
export * from "./analogClock.vue?vue&type=script&lang=js"

import "./analogClock.vue?vue&type=style&index=0&id=0bd00e92&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd00e92"]])

export default __exports__